// ============================================================================
// Nu-Link Constants — VID/PID, Command Opcodes, HID Filters
// ============================================================================

/** Nuvoton Nu-Link USB Vendor ID */
export const NULINK_VID = 0x0416;

/** Known Nu-Link Product IDs */
export const NULINK_PIDS = {
  NU_LINK_ME:      0x511B,  // Nu-Link-Me (on Nu-Tiny boards)
  NU_LINK:         0x511C,  // Nu-Link standalone
  NU_LINK_PRO:     0x511D,  // Nu-Link-Pro
  NU_LINK2_ME:     0x5200,  // Nu-Link2-Me
  NU_LINK2_FW:     0x5211,  // Nu-Link2 firmware upgrade mode
} as const;

/** HID device filters for navigator.hid.requestDevice() */
export const NULINK_HID_FILTERS: HIDDeviceFilter[] = [
  { vendorId: NULINK_VID, productId: NULINK_PIDS.NU_LINK_ME },
  { vendorId: NULINK_VID, productId: NULINK_PIDS.NU_LINK },
  { vendorId: NULINK_VID, productId: NULINK_PIDS.NU_LINK_PRO },
  { vendorId: NULINK_VID, productId: NULINK_PIDS.NU_LINK2_ME },
  { vendorId: NULINK_VID, productId: NULINK_PIDS.NU_LINK2_FW },
];

/** Nu-Link ICP command opcodes */
export enum NuLinkCmd {
  GET_VERSION    = 0x00,
  READ_CONFIG    = 0xA1,
  SET_CONFIG     = 0xA2,
  ERASE          = 0xA3,
  WRITE          = 0xA5,
  READ           = 0xA7,
  GET_DEVICE_ID  = 0xA8,
  RUN_APROM      = 0xAB,
  RUN_LDROM      = 0xAC,
  DISCONNECT     = 0xAD,
  RESET          = 0xAE,
  CONNECT        = 0xAF,
  GET_UID        = 0xB0,
}

/** HID report size for all Nu-Link communications */
export const NULINK_REPORT_SIZE = 64;

/** Max data payload per write command (64 - 16 header bytes) */
export const NULINK_MAX_WRITE_PAYLOAD = 48;

/** Default ICP clock speed in kHz */
export const NULINK_DEFAULT_CLOCK_KHZ = 1000;

/** Default target VCC in mV */
export const NULINK_DEFAULT_VCC_MV = 3300;
